"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17 0H3c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H4V7h12v11zm0-12H4V2h12v4z"];
//# sourceMappingURL=widget-header.js.map